/**
 * Created by Viacheslav Stepanian on 15.12.2025
 */

const SignInViralWindow = CleverappsWindow.extend({
    onWindowLoaded: function (options) {
        options = options || {};

        this.options = options;
        this.model = new SignInModel(options);
        this.model.closeWindow = this.createListener(this.close, this);

        const styles = cleverapps.styles.SignInWindow;

        const items = [];

        const animation = new cleverapps.Spine(bundles.sign_in_viral_window.jsons.sign_in_icon_json);
        animation.setAnimationAndIdleAfter("open", "idle");
        items.push(animation);

        const text1 = this.createText(Messages.get("SignInViralWindow.text1"));
        items.push(text1);

        if (options.errorMessage) {
            const error = cleverapps.UI.generateOnlyText(options.errorMessage, cleverapps.styles.FONTS.SMALL_TEXT_ERROR);
            error.setFontSize(styles.text.fontSize);
            error.setDimensions(text1.width, 0);
            error.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            items.push(error);
        }

        items.push(this.createButtons());

        const content = new cleverapps.Layout(items, {
            margin: styles.margin,
            direction: cleverapps.UI.VERTICAL
        });

        this._super({
            title: Messages.get("SignInViralWindow.title"),
            closeButton: true,
            name: "signinviralwindow",
            content
        });
    },

    createText: function (msg) {
        const styles = cleverapps.styles.SignInViralWindow;

        const text = cleverapps.UI.generateOnlyText(msg, cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
        text.setFontSize(styles.text.fontSize);
        text.setDimensions(styles.text.width, 0);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        return new cleverapps.Layout([text], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.text.margin
        });
    },

    onClose: function () {
        this.model.handleClose();
    },

    createButtons: function () {
        let socials = connector.social.listAvailable();

        if (cleverapps.config.debugMode && this.options.socials) {
            socials = this.options.socials;
        }

        const styles = cleverapps.styles.SignInViralWindow;

        const buttons = socials.map(function (source) {
            return new LoginButton({
                multiSocials: socials.length > 1,
                height: styles.button.height,
                width: styles.button.width,
                source,
                onSuccess: () => this.model.handleLoginClick()
            });
        }, this);

        return new cleverapps.Layout(buttons, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.button.margin,
            padding: styles.button.padding
        });
    },

    listBundles: function () {
        return ["sign_in_viral_window"];
    }
});

cleverapps.styles.SignInViralWindow = {
    margin: 30,

    button: {
        height: 110,
        width: 500,
        margin: 20,
        padding: {
            top: 20,
            bottom: 30
        }
    },

    text: {
        fontSize: 40,

        width: 720,
        margin: 20
    },

    footer: {
        fontSize: 30
    }
};
